import { FC, useMemo } from 'react';

import { DateRange, DateRangePicker } from '/shared/DateRangePicker';
import { PersistedQueryKeys } from '/common/models';

import { store } from '../../hook';
import { AttachmentPickerStyled } from '../../styles';
import { TAttachmentPickerProps } from '../../types';

export const AttachmentPicker: FC<TAttachmentPickerProps> = ({ range, handleRange }) => {
  const dateRange = useMemo<DateRange>(() => [range.from, range.to], [range.from, range.to]);
  const attachmentsQuery = {
    from: range.from.toISOString(),
    to: range.to.toISOString(),
  };
  const handleDateRangeChange = (selectedRange: DateRange) => {
    handleRange('from', selectedRange[0] || range.from);
    handleRange('to', selectedRange[1] || range.to);

    store.set(PersistedQueryKeys.Attachments, JSON.stringify(attachmentsQuery));
  };

  return (
    <AttachmentPickerStyled>
      <DateRangePicker dateRange={dateRange} onDateRangeChange={handleDateRangeChange} label='Time range' />
    </AttachmentPickerStyled>
  );
};
